import { Component, computed, inject, input, output } from "@angular/core"
import { RouteService } from "../../services/route.service"
import { EditorContext, EditorService } from "./services/editor.service"
import { ProfileService } from "../user-profile/profile.service"
import { faTrash, faYinYang } from "@fortawesome/free-solid-svg-icons"
import { UiIconComponent } from "ui-icon"
import { UiConfirmComponent } from "ui-confirm"

@Component({
  imports: [
    UiIconComponent,
    UiConfirmComponent,
  ],
  standalone: true,
  template: `
    <div class="row w-full justify-between flex-nowrap">

      @if (contributorContext()) {
        @if (needsChanges()) {
          <button
            class="btn btn-sm btn-accent"
            [disabled]="saving() || preSaving()"
            (click)="resubmitForReviewAndClose.emit()"
          >
            Re-submit for review
          </button>
        }
        @if (!needsChanges()) {
          <button
            class="btn btn-sm btn-accent"
            [disabled]="saving() || preSaving()"
            (click)="saveAndClose.emit()"
          >
            Save
          </button>
        }
      }

      @if (moderationContext()) {
          <button
            class="btn btn-sm btn-accent"
            [disabled]="saving() || preSaving() || needsChanges()"
            (click)="approveAndClose.emit()"
          >
            Approve
          </button>
          <button
            class="btn btn-sm btn-accent"
            [disabled]="saving() || preSaving() || !needsChanges()"
            (click)="rejectAndClose.emit()"
          >
            Reject
          </button>
      }

      @if (!autosave() && !moderationContext() && !contributorContext()) {
        @if (!saving()) {
          <button
            class="btn btn-sm btn-accent"
            (click)="saveAndClose.emit()"
          >
            Save
          </button>
        }
        @if (saving()) {
          <button class="btn btn-sm btn-accent">
            <lib-ui-icon
              [icon]="faYinYang"
              class="pr-0 text-md"
              animation="spin"
            />
          </button>
        }
      }

      @if (adminContext() || moderationContext()) {
        <lib-ui-confirm
          [options]="{ triggerButtonText: 'Delete', icon: faTrash, classes: ['btn-accent'], cancelClasses: ['btn-accent'], confirmClasses: ['btn-accent'] }"
          (confirmed)="deleteAndClose.emit()"
        />
      }


    </div>
  `,
  selector: "e2e-editor-footer",
})
export class EditorFooterComponent {
  private routeService = inject(RouteService)
  private editorService = inject(EditorService)
  private profileService = inject(ProfileService)

  context = input.required<EditorContext>()

  close = output()
  resubmitForReviewAndClose = output()
  approveAndClose = output()
  rejectAndClose = output()
  saveAndClose = output()
  deleteAndClose = output()

  adminContext = computed(() => this.context() === "admin")
  contributorContext = computed(() => this.context() === "contributor")
  moderationContext = computed(() => this.context() === "moderation")
  preSaving = this.editorService.preSaving
  // section = this.routeService.sectionFlags
  saving = this.editorService.saving
  passedReview = this.editorService.passedReview
  // needsChanges = this.editorService.needsChanges
  isEditor = this.profileService.isEditor
  autosave = this.editorService.autosave

  needsChanges = computed(() => this.editorService.editorContent()?.status.reviewFeedbacks.length)

  protected readonly faYinYang = faYinYang
  protected readonly faTrash = faTrash
}
